import React, {Component} from 'react';
import ParameterErrors from '../errors/ParameterErrors';
export default class GoogleAnalytics{
	constructor(props){
		const {trackingCode, siteName}=props;
		const script = document.createElement('script');
		script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingCode}`;
		document.body.appendChild(script);
		script.addEventListener('load', ()=>{
			window.dataLayer = window.dataLayer || [];
			GoogleAnalytics._gtag('js', new Date());
			GoogleAnalytics._gtag('config', trackingCode);
		});
		script.addEventListener('error', console.error);
    }
	static logEvent(name, parameters){
		try{
			GoogleAnalytics._gtag('event', name, parameters);
		}catch(error){
			console.error(error);
		}
	}
	static get instance(){
		return GoogleAnalytics._instance;
	}
	static _gtag(){window.dataLayer?.push(arguments);}
	static logFavouritesBrochureRequest(siteName){
		try{
			GoogleAnalytics._gtag('event', 'brochure_request', {
			  'event_category': 'Favourites Brochure',
			  'event_label': siteName
			});
		}
		catch(err){
			console.error(err);
		}
	}
	static logPlotBrochureRequest(siteName, plotNumber){
		try{
			GoogleAnalytics._gtag('event', 'brochure_request', {
			  'event_category': 'Plot Brochure',
			  'event_label': `${siteName} - Plot ${plotNumber}`
			});
		}
		catch(err){
			console.error(err);
		}
	}
}